import styled, { css } from 'styled-components'

const SelectField = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(0.75)};
  `}
`

const Select = styled.select`
  ${({ theme }) => css`
    width: 100%;
    min-width: calc(14ch + ${theme.spacing(4)});
    padding: ${theme.spacing(1)} ${theme.spacing(5)} ${theme.spacing(1)} ${theme.spacing(1)};
    font-size: 1.4rem;
    background-color: ${theme.palette.grey[700]};
    border: none;
    color: #ffffff;
    appearance: initial;
    border-radius: 0;
    text-overflow: ellipsis;
    text-indent: ${theme.spacing(4)};
    cursor: pointer;

    &.hasError {
      border-color: #da2f47;
    }

    &:hover {
      background-color: ${theme.palette.grey[600]};
    }

    &:focus {
      outline: 0.2rem solid #000;
      border-color: transparent;
    }
  `}
`

const Wrapper = styled.div`
  position: relative;
`

const Caret = styled.div`
  ${({ theme }) => css`
    svg {
      position: absolute;
      right: ${theme.spacing(2)};
      top: 50%;
      transform: translateY(-50%);
      pointer-events: none;
      color: white;
    }
  `}
`

const Flag = styled.div`
  ${({ theme }) => css`
    svg {
      position: absolute;
      left: ${theme.spacing(2)};
      top: 50%;
      transform: translateY(-50%);
      pointer-events: none;
    }
  `}
`

export default {
  SelectField,
  Select,
  Wrapper,
  Caret,
  Flag,
}
